// eslint-disable-next-line no-unused-vars
import React from 'react'

const InviteLayout = ({ children }) => children

export default InviteLayout
